// extracted by mini-css-extract-plugin
export default {"container":"ContactForm_container__UfkMj","link":"ContactForm_link__0z3Um"};